module.exports = __webpack_public_path__ + "media/images/about_us_hero-d8c2f3f33acb81179ef4d85b701ff9140073d7e22919f68908b492800ead2237.jpg";